import React, {useState} from 'react';
import './index.css';
import HorizontalVector from "./HorizontalVector";
import VerticalVector from "./VerticalVector";
import PieChart from "./PieChart";
import Items from "./items";

function TestsResult(props) {
    const [detail, setDetail] = useState("mamad")
    const test_title = {
        "reasoning": {
           "title" : "تفکر و استدلال",
           "data" : "به معنی قدرت مغز در سازماندهی و استفاده بهینه از اطلاعات، ارتباطات و الگوهای دریافتی مختلف، برای انجام کارهای پیچیده و همچنین توانایی برنامه‌ریزی برای رسیدن به اهداف از پیش تعیین شده است. توانایی استفاده کارآمد از اطلاعات دریافتی از حواس مختلف برای انجام کارهای پیچیده و حل مسائل گوناگون! این توانایی به ما این امکان را می‌دهد تا ایده‌ها و افکار خود را سازماندهی و دسته بندی کنیم و با کمک آن‌ها مسائل پیش روی خود را حل کنیم و در مواقع مختلف، تصمیم‌های درست و منطقی بگیریم."
        },
        "Inhibition": {
            "title":"بازداری",
            "data":"به این مهارت، توانایی مهار پاسخ هم می‌گن و به این درد می‌خوره تا فرد بتونه واکنش‌ها و پاسخ‌های اتوماتیک خودش رو کنترل کنه و به محرک‌ها جواب فکر شده و با دقت بده. در واقع این مهارت، با مهار رفتارها و واکنش‌های خودبخودی نابجا، به فرد این امکان رو می‌ده تا در موقعیت‌های هیجانی گوناگون، پاسخ‌های مناسب رو داشته باشه!"
        },
        "working_memory": {
            "title":"حافظه کلامی",
            "data":"این مهارت که بخشی از حافظه فعال یا کاری رو تشکیل می‌ده، به معنی توانایی به خاطرسپاری اطلاعات شنیداریه که می‌تونه هم شامل اصوات بیرونی و هم اصوات درونی (مثل تو ذهن خوندن) باشه. این که ما بتونیم از طریق شنیدن و یا خوندن یه مطلبی، اون رو به خاطر بسپریم برمی‌گرده به این مدل از حافظه‌مون."
        },
        "visual_memory": {
            "title":"حافظه تصویری",
            "data":"این مهارت که بخشی از حافظه فعال یا کاری رو تشکیل می‌ده، به معنی توانایی به خاطرسپاری اطلاعات دیداری مانند شکل، رنگ، موقعیت مکانی، چهره و ... هست."
        },
        "flexibility": {
            "title":"انعطاف پذیری",
            "data":"این مهارت یعنی توانایی مغز برای ایجاد تغییر در افکار و رفتار، هنگام ورود به یک موقعیت جدید و غیرمنتظره! یعنی این که بتونی متوجه بشی کاری که داری انجام می‌دی دیگه جواب نمی‌ده پس تغییراتی رو تو خودت به وجود بیاری تا از پس شرایط و موقعیت جدید بربیای! این مهارت نقش مهمی تو یادگیری و حل مساله داره."
        },
        "Processing": {
            "title":"سرعت پردازش",
            "data":"مدت زمانی که طول می‌کشه تا فرد یه کار ذهنی رو انجام بده، سرعت پردازش مغزش رو نشون می‌ده. این زمان از لجظه دریافت اظلاعات تا ادراک اون و شروع واکنش که می‌تونه به صورت کلامی یا حرکتی باشه، ادامه داره."
        },
        "attention": {
            "title":"دقت و توجه",
            "data":"به توانایی دریافتِ جزئیاتِ مرتبط با یک موضوع و در عین حال نادیده گرفتن اطلاعات نامربوط به اون، مهارت توجه می‌گن! یه جورایی قابلیت فیلتر کردن مزاحمت‌ها و حواس‌پرتی‌ها و تمرکز بر روی دریافت اطلاعات مرتبط با کار مورد نظر. دقت و توجه تقریبا روی تمام عملکردها و فرآیندهای شناختی تاثیرگذار هست و از نیازهای اساسی برای بهتر شدن مهارت‌هایی مانند حافظه و تفکر به حساب می‌آد.\n" +
                "\n"
        },
    }

    return (

        (detail !== "mamad") ?
            <>
                <div
                    className="flex flex-row-reverse border-[min(0.5vw,1vh)] rounded-[min(1vw,2vh)] justify-center items-center h-[min(6vw,12vh)] text-white my-[min(1vw,2vh)] bg-[#001037]"
                    style={{
                        backgroundColor: `${props.stateData["test_result"][detail]["total"] > 0 ? "#CCFFCF" : "#FFE8CC"}`,
                        borderColor: `${props.stateData["test_result"][detail]["total"] > 0 ? "#00FF57" : "#FFB648"}`
                    }}>
                    <div className="flex flex-col justify-center items-center h-[70%] rounded-[min(1vw,2vh)] m-[1%] w-[8%] p-[1%] text-black cursor-pointer text-[min(1vw,2vh)] bg-[#f6af00]" onClick={()=>{setDetail("mamad")}}>
                        بازگشت >
                    </div>
                    <div className="flex flex-row-reverse justify-center items-center h-[90%] w-[80%] ml-[10%]">


                    <img className="h-[80%] m-[min(1.5vw,3vh)]"
                         src={`https://uploads.zibazi.tv/site/assets/organ/dashboard/${props.stateData["test_result"][detail]["total"] > 0 ? "good" : "bad"}.png`}
                         alt="icon"/>
                    <span className="text-[min(2.5vw,5vh)] text-black font-[700]">
                                         {test_title[detail]["title"]}
                                    </span>

                </div>
                </div>
                <div
                    className="flex flex-col text-[min(1vw,2vh)] w-full h-[min(40vw,80vh)] p-[min(0.5vw,1vh)] bg-[#001037] rounded-[min(1vw,2vh)] overflow-hidden justify-center items-center">
                    <div className="flex flex-col justify-center items-center text-white w-[90%] rounded-[min(1vw,2vh)] bg-[#0f2458] p-[min(2vh,1vw)]">
                        <div className="flex text-[min(1vw,2vh)] flex-col w-[90%] justify-center items-center text-white leading-[min(2.5vw,5vh)]" dir="rtl">
                            {test_title[detail]["data"]}
                        </div>
                    </div>
                    <div className="flex flex-row w-full justify-center items-center">
                        <div
                            className="flex items-center justify-center w-[min(20vw,40vh)] p-[min(1vw,2vh)] h-[min(20vw,40vh)] mb-[min(1vw,2vh)] relative top-[5%]">
                            <div className={`flex items-center justify-center w-full h-full rounded-full transition-all duration-700 transition-transform duration-500 transform`} style={{backgroundImage: `conic-gradient(#ff757c ${((props.stateData["test_result"][detail]["negative"] / (props.stateData["test_result"][detail]["negative"] + props.stateData["test_result"][detail]["positive"])*100))+"%"}, #00c844 ${((props.stateData["test_result"][detail]["negative"] / (props.stateData["test_result"][detail]["negative"] + props.stateData["test_result"][detail]["positive"])*100))+"%"})`}}>
                            </div>
                        </div>
                        <div className="flex flex-col w-[30%]">
                            <Items color={"#00c844"} title={"بالاتر از میانگین(درصد)"}
                                   amount={(props.stateData["test_result"][detail]["positive"] / (props.stateData["test_result"][detail]["negative"] + props.stateData["test_result"][detail]["positive"])*100)}
                                   font_size_number={"min(1.5vw,3vh)"} font_size={"min(1.3vw,2.6vh)"}/>
                            <Items color={"#ff757c"} title={"پایین از میانگین(درصد)"}
                                   amount={(props.stateData["test_result"][detail]["negative"] / (props.stateData["test_result"][detail]["negative"] + props.stateData["test_result"][detail]["positive"])*100)}
                                   font_size_number={"min(1.5vw,3vh)"} font_size={"min(1.3vw,2.6vh)"}/>
                        </div>
                    </div>

                </div>
                </>
            :
            <>
                <div
                    className="flex flex-row-reverse rounded-[min(1vw,2vh)] justify-center items-center h-[min(12vw,24vh)] text-white my-[min(1vw,2vh)] bg-[#001037]">
                    <div className="flex flex-col justify-center items-center h-full w-full">
                        <div
                            className="flex justify-center items-center h-[70%] font-[700] text-[min(3.5vw,7vh)]">{props.stateData["test_result"]["iq"]["count"]}</div>
                        <div className="flex justify-center items-start h-[40%] text-[min(1.5vw,3vh)]">مشارکت در ماموریت
                            ها (دانش آموز)
                        </div>
                    </div>
                </div>
                <div
                    className="flex flex-row text-[min(1vw,2vh)] w-full h-[min(35vw,70vh)] p-[min(0.5vw,1vh)] bg-[#001037] rounded-[min(1vw,2vh)] overflow-hidden justify-center items-center">
                    <div className="flex flex-col h-full w-full justify-center items-center">
                        <div
                            className="flex flex-row-reverse justify-center h-[25%] mb-[2%] w-[30%] text-white text-[min(1.5vw,3vh)] border-b-2 border-white text-right items-center">
                            <img className="h-[35%]"
                                 src={"https://uploads.zibazi.tv/site/assets/organ/dashboard/iq.png"} alt="icon"/>
                            <span className="mr-[min(1vw,2vh)] text-[min(2vw,4vh)]">
                            میانگین
                        </span>
                            <span className="mx-[min(1vw,2vh)] text-[min(2vw,4vh)]">
                             : IQ
                        </span>
                            <span className="text-[min(2vw,4vh)]">
                             {parseInt(props.stateData["test_result"]["iq"]["total"] / props.stateData["test_result"]["iq"]["count"]).toLocaleString()}
                        </span>
                        </div>

                        <div className="flex flex-row-reverse justify-center items-center h-[60%] w-full">

                            <div
                                className="flex flex-row-reverse flex-wrap w-full h-full justify-start items-center text-white">
                                {Object.keys(props.stateData["test_result"]).map((key, index) => (
                                    key !== "iq" && props.stateData["test_result"][key]["count"] !== 0 &&
                                    <div
                                        className={"flex cursor-pointer flex-row-reverse items-center justify-start mr-[2%] w-[30%] h-[20%] border-2 rounded-[min(1vw,2vh)]"}
                                        style={{
                                            backgroundColor: `${props.stateData["test_result"][key]["positive"] > props.stateData["test_result"][key]["negative"] ? "#CCFFCF" : "#FFE8CC"}`,
                                            borderColor: `${props.stateData["test_result"][key]["positive"] > props.stateData["test_result"][key]["negative"] ? "#00FF57" : "#FFB648"}`
                                        }} onClick={()=>{setDetail(key)}} key={key}>
                                        <img className="h-[60%] m-[min(1.5vw,3vh)]"
                                             src={`https://uploads.zibazi.tv/site/assets/organ/dashboard/${props.stateData["test_result"][key]["positive"] > props.stateData["test_result"][key]["negative"] ? "good" : "bad"}.png`}
                                             alt="icon"/>
                                        <span className="text-[min(1.5vw,3vh)] text-black">
                                         {test_title[key]["title"]}
                                    </span>
                                    </div>
                                ))}

                            </div>

                        </div>
                        <div
                            className="text-[#CCFFCF] text-[min(1.3vw,2.6vh)] h-[15%] flex justify-center items-center">
                            وضعیت سبز در هر پارامتر بیانگر بهتر بودن میانگین این استان نسبت به کل شرکت کنندگان است *
                        </div>
                    </div>
                </div>
            </>
    );
}

export default TestsResult;